import React, { useContext, useEffect, useState } from "react";
import Image from "next/image";
import dayjs from "dayjs";
import { CopyToClipboard } from "react-copy-to-clipboard";

//internal import
import useAsync from "@hooks/useAsync";
import CouponServices from "@services/CouponServices";
import OfferTimer from "@component/coupon/OfferTimer";
import SkuToTitle from "./SkuToTitle";
import { UserContext } from "@context/UserContext";

const Coupon = ({ couponInHome }) => {
  const [copiedCode, setCopiedCode] = useState("");
  const [copied, setCopied] = useState(false);
  const [accountAgeFromNow, setAccountAgeFromNow] = useState(0);

  const { data, error } = useAsync(CouponServices.getShowingCoupons);

  const {
    state: { userInfo },
  } = useContext(UserContext);

  useEffect(() => {
    if (userInfo) {
      const d1 = new Date(userInfo?.signed_up_on);
      const d2 = new Date();
      var months;
      months = (d2.getFullYear() - d1.getFullYear()) * 12;
      months -= d1.getMonth();
      months += d2.getMonth();
      months <= 0 ? 0 : months;
      setAccountAgeFromNow(months);
    } else {
      setAccountAgeFromNow(0);
    }
  }, [userInfo]);

  const handleCopied = (code) => {
    setCopiedCode(code);
    setCopied(true);
  };

  return <>
    {error ? (
      <p className="flex justify-center align-middle items-center m-auto text-xl text-red-500">
        <span> {error}</span>
      </p>
    ) : couponInHome ? (
      data?.slice(0, 2).map((coupon) => (
        <div
          key={coupon._id}
          className="coupon coupon-home mx-4 my-5 block md:flex lg:flex md:justify-between lg:justify-between items-center bg-white rounded-md shadow"
        >
          <div className="tengah py-2 px-3 flex items-center justify-items-start">
            <figure>
              <Image
                src={coupon.logo}
                alt={coupon.title}
                width={100}
                height={100}
                className="rounded-lg"
                placeholder="blur"
                blurDataURL="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                style={{
                  maxWidth: "100%",
                  height: "auto"
                }} />
            </figure>
            <div className="ml-3">
              <div className="flex items-center font-serif">
                <h6 className="pl-1 text-base font-medium text-gray-600">
                  <span className="text-lg md:text-xl lg:text-xl text-red-500 font-bold">
                    {coupon.discountAmountOrPercentage}{" "}
                    {coupon.discountType.localeCompare("Flat") === 0
                      ? "TK"
                      : "%"}
                  </span>{" "}
                  Off
                </h6>
                <div className="ml-2">
                  {dayjs().isAfter(dayjs(coupon.endTime)) ? (
                    <span className="text-red-600 inline-block px-4 py-1 rounded-full font-medium text-xs bg-red-100">
                      Expired
                    </span>
                  ) : (
                    <span className="text-emerald-600 inline-block px-4 py-1 rounded-full font-medium text-xs bg-emerald-100">
                      Active
                    </span>
                  )}
                </div>
              </div>
              <h2 className="pl-1 font-serif text-base text-gray-700 leading-6 font-semibold mb-2">
                {coupon.title}
              </h2>
              {dayjs().isAfter(dayjs(coupon.endTime)) ? (
                <span className="inline-block mb-2">
                  <div className="flex items-center font-semibold">
                    <span className="flex items-center justify-center bg-red-500 text-white text-sm font-serif font-semibold mx-1 px-2 py-1 rounded">
                      00
                    </span>
                    :
                    <span className="flex items-center justify-center bg-red-500 text-white text-sm font-serif font-semibold mx-1 px-2 py-1 rounded">
                      00
                    </span>
                    :
                    <span className="flex items-center justify-center bg-red-500 text-white text-sm font-serif font-semibold mx-1 px-2 py-1 rounded">
                      00
                    </span>
                    :
                    <span className="flex items-center justify-center bg-red-500 text-white text-sm font-serif font-semibold mx-1 px-2 py-1 rounded">
                      00
                    </span>
                  </div>
                </span>
              ) : (
                <span className="inline-block mb-2">
                  <div className="flex items-center font-semibold">
                    <OfferTimer
                      expiryTimestamp={new Date(coupon.endTime)}
                      darkGreen
                    />
                  </div>
                </span>
              )}
            </div>
          </div>
          <div className="md:border-l-2 lg:border-l-2 border-dashed lg:w-1/3 md:w-1/3 relative px-4">
            <div className="info flex items-center">
              <div className="w-full">
                <div className="block">
                  <div className="font-serif border border-dashed bg-emerald-50 py-1 px-1 border-emerald-300 rounded-lg text-center block overflow-hidden">
                    <CopyToClipboard
                      text={coupon.couponCode}
                      onCopy={() => handleCopied(coupon.couponCode)}
                    >
                      <button className="block w-full">
                        {copied && coupon.couponCode === copiedCode ? (
                          <span className="text-emerald-600 text-sm leading-7 font-semibold">
                            Copied!
                          </span>
                        ) : (
                          <span className="uppercase font-serif font-semibold text-sm leading-7 text-emerald-600">
                            {coupon.couponCode}{" "}
                          </span>
                        )}
                      </button>
                    </CopyToClipboard>
                  </div>
                </div>
                {coupon.elligibleType.localeCompare("minimum_order") ===
                  0 && (
                  <p className="text-xs leading-4 text-gray-500 mt-2">
                    * This coupon apply when shopping more than{" "}
                    <span className="font-bold">
                      {" "}
                      ৳{coupon.minimumAmount}
                    </span>{" "}
                  </p>
                )}

                {coupon.elligibleType.localeCompare("account_age") === 0 && (
                  <p className="text-xs leading-4 text-gray-500 mt-2">
                    * This coupon apply when your account age is more than or
                    equal to{" "}
                    <span className="font-bold">
                      {" "}
                      {coupon.minimumAccountAge} months
                    </span>{" "}
                  </p>
                )}

                <SkuToTitle coupon={coupon} />
                {coupon.elligibleType.localeCompare("email") === 0 && (
                  <p className="text-xs leading-4 text-gray-500 mt-2">
                    * This coupon apply when your account is under elligible
                    emails{" "}
                  </p>
                )}
                {coupon.elligibleType.localeCompare("product") === 0 && (
                  <p className="text-xs leading-4 text-gray-500 mt-2">
                    * This coupon apply when your order item is under{" "}
                    <span className="font-bold"> {coupon.productType}</span>{" "}
                    category
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      ))
    ) : (
      data?.map((coupon) => {
        if (accountAgeFromNow >= coupon?.minimumAccountAge) {
          return (
            <div
              key={coupon._id}
              className="coupon block md:flex lg:flex md:justify-between lg:justify-between items-center bg-white rounded-md shadow-sm"
            >
              <div className="tengah p-6 flex items-center justify-items-start">
                <figure>
                  <Image
                    src={coupon.logo}
                    alt={coupon.title}
                    width={120}
                    height={120}
                    className="rounded-lg"
                    style={{
                      maxWidth: "100%",
                      height: "auto"
                    }} />
                </figure>
                <div className="ml-5">
                  {dayjs().isAfter(dayjs(coupon.endTime)) ? (
                    <span className="inline-block mb-2">
                      <div className="flex items-center font-semibold">
                        <span className="flex items-center justify-center bg-red-100 text-sm font-serif font-semibold px-2 py-1 rounded mx-1">
                          00
                        </span>
                        :
                        <span className="flex items-center justify-center bg-red-100 text-sm font-serif font-semibold px-2 py-1 rounded mx-1">
                          00
                        </span>
                        :
                        <span className="flex items-center justify-center bg-red-100 text-sm font-serif font-semibold px-2 py-1 rounded mx-1">
                          00
                        </span>
                        :
                        <span className="flex items-center justify-center bg-red-100 text-sm font-serif font-semibold px-2 py-1 rounded mx-1">
                          00
                        </span>
                      </div>
                    </span>
                  ) : (
                    <span className="inline-block mb-2">
                      <div className="flex items-center font-semibold">
                        <OfferTimer
                          expiryTimestamp={new Date(coupon.endTime)}
                        />
                      </div>
                    </span>
                  )}

                  <h2 className="font-serif text-lg leading-6 font-medium mb-3">
                    {coupon.title}
                  </h2>
                  <p className="font-serif font-bold text-xl text-gray-600">
                    <span className="text-lg md:text-xl lg:text-2xl leading-12 text-red-500 font-extrabold">
                      {coupon.discountAmountOrPercentage}{" "}
                      {coupon.discountType.localeCompare("Flat") === 0
                        ? "৳"
                        : "%"}
                    </span>{" "}
                    Off
                  </p>
                </div>
              </div>
              <div className="md:border-l-2 lg:border-l-2 border-dashed lg:w-1/3 md:w-1/3 relative px-6">
                <div className="info flex lg:my-6 md:my-5 mb-6 items-center">
                  <div className="w-full">
                    <div className="block">
                      <div className="font-serif font-medium flex items-center mb-1">
                        <span>Coupon</span>
                        <div className="ml-2">
                          {dayjs().isAfter(dayjs(coupon.endTime)) ? (
                            <span className="text-red-600 inline-block">
                              Expired
                            </span>
                          ) : (
                            <span className="text-emerald-600 inline-block">
                              Active
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="font-serif border border-dashed bg-emerald-50 py-2 border-emerald-300 rounded-lg text-center block">
                        <CopyToClipboard
                          text={coupon.couponCode}
                          onCopy={() => handleCopied(coupon.couponCode)}
                        >
                          <button className="block w-full">
                            {copied && coupon.couponCode === copiedCode ? (
                              <span className="text-emerald-600 text-base leading-7 font-semibold">
                                Copied!
                              </span>
                            ) : (
                              <span className="font-serif font-semibold text-base leading-7 text-emerald-600">
                                {coupon.couponCode}{" "}
                              </span>
                            )}
                          </button>
                        </CopyToClipboard>
                      </div>
                    </div>

                    {coupon.elligibleType.localeCompare("minimum_order") ===
                      0 && (
                      <p className="text-xs leading-4 text-gray-500 mt-2">
                        * This coupon apply when shopping more than or equal
                        to{" "}
                        <span className="font-bold">
                          {" "}
                          ৳{coupon.minimumAmount}{" "}
                        </span>{" "}
                      </p>
                    )}

                    {coupon.elligibleType.localeCompare("account_age") ===
                      0 && (
                      <p className="text-xs leading-4 text-gray-500 mt-2">
                        * This coupon apply when your account age is more than
                        or equal to{" "}
                        <span className="font-bold">
                          {" "}
                          {coupon.minimumAccountAge} months
                        </span>{" "}
                      </p>
                    )}
                    <SkuToTitle coupon={coupon} />
                    {coupon.elligibleType.localeCompare("email") === 0 && (
                      <p className="text-xs leading-4 text-gray-500 mt-2">
                        * This coupon apply when your account is under
                        elligible emails{" "}
                      </p>
                    )}
                    {coupon.elligibleType.localeCompare("product") === 0 && (
                      <p className="text-xs leading-4 text-gray-500 mt-2">
                        * This coupon apply when your order item is under{" "}
                        <span className="font-bold">
                          {" "}
                          {coupon.productType}
                        </span>{" "}
                        category
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        } else null;
      })
    )}
  </>;
};

export default Coupon;
